export interface FirebaseWebConfig {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId?: string;
  measurementId?: string;
}

let runtimeFirebaseConfig: FirebaseWebConfig | null = null;

export const setRuntimeFirebaseConfig = (config: FirebaseWebConfig): void => {
  runtimeFirebaseConfig = { ...config };
};

export const getRuntimeFirebaseConfig = (): FirebaseWebConfig | null => {
  return runtimeFirebaseConfig ? { ...runtimeFirebaseConfig } : null;
};

export const clearRuntimeFirebaseConfig = (): void => {
  runtimeFirebaseConfig = null;
};

